import { render, staticRenderFns } from "./text-list.vue?vue&type=template&id=ab43b266&scoped=true&"
import script from "./text-list.vue?vue&type=script&lang=js&"
export * from "./text-list.vue?vue&type=script&lang=js&"
import style0 from "./text-list.vue?vue&type=style&index=0&id=ab43b266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab43b266",
  null
  
)

export default component.exports